import { buildApiUrl, Type, sendGetRequest } from '@/api/api'
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export const providerSchema = z.array(z.object({
  Id: z.number(),
  ProvinceId: z.number(),
  Name: z.string(),
  TimeOfUseProfileId: z.number().nullable(),
  Linked: z.number(), 
}))

export async function fetchProviders(provinceIds?: number[]) {
  const query = Array.isArray(provinceIds) && provinceIds.length > 0
    ? '?' + provinceIds.map(id => `provinceIds=${id}`).join('&')
    : '';

  const url = buildApiUrl(Type.TariffManagement, `providers${query}`);
  const { data } = await sendGetRequest(url);
  return assertSchemaAndCoerce(data, providerSchema);
}


